import { applyMiddleware, createStore, AnyAction } from 'redux';
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createMiddleware as abtestingMiddleware, getExperiments, track } from '@pegasus/abtesting';
import { reducer } from './reducer';

export function configureStore(initialState: any = {}) {
    const abtesting = abtestingMiddleware({
        endpoint: '/api/abtesting',
        initialExperiments: getExperiments(initialState) as any,
        onExperimentLoad: track,
    });

    const thunk: ThunkMiddleware<any, AnyAction> = thunkMiddleware;
    const middlewares = applyMiddleware(thunk, abtesting);
    const store = createStore(reducer, initialState, composeWithDevTools(middlewares));

    return store;
}
